import React from 'react';
import { fromPairs, map, isEqual } from 'lodash';

// local dependencies
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';
import { popover } from 'modules/popover';
import { Form } from 'modules/form';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { wellViewAdministrationEditContact as WellViewAdministrationEditContact } from 'ui/views/widgets/wellViewAdministrationEditContact';
 *
 * // render
 * <WellViewAdministrationEditContact propName='propValue'/>
 */
export const wellViewAdministrationEditContact = ( props ) => {
    return (
        <div className='ui-well-view-administration-edit-contact'>
            <div className='ui-add-edit-communication-settings'>
                <div className='ui-add-edit-communication-settings__header'>

                    {/* title for the modal */}
                    <div className='ui-add-edit-communication-settings__header__title'>
                        { props.itemData.title }
                    </div>

                    {/* close button */}
                    <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                        <Icon name='close' width='14' height='14' fill='#ffffff' />
                    </div>

                </div>

                <div className='ui-add-edit-communication-settings__body'>
                    <Form
                        fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                        values={ props.itemData } // default values
                        isValid={ false }
                        onSubmit={ ( { values, isValid } ) => {
                            if( isValid ) {
                                popover.close();
                                props.onSumbitClick( {
                                    contactNo: values.contact
                                } );
                            }
                        } }
                    >
                        { ( { fields, values, /**isValid,*/ errors, onChange, onSumbit } = {} ) => {

                            return (
                                <form
                                    onSubmit={ onSumbit }
                                    className='ui-add-edit-communication-settings__body__form'
                                >
                                    { /* fields */ }
                                    { map( fields, ( field ) => {
                                        
                                        return (
                                            <field.view
                                                className='ui-add-edit-communication-settings__body__form__field'
                                                key={ field.name }
                                                name={ field.name }
                                                required={ field.required }
                                                placeholder={ field.placeholder }
                                                label={ field.title }
                                                onChange={ onChange }
                                                value={ values[ field.name ] }
                                                error={ errors[ field.name ] }
                                                mask={ field.mask }
                                            />
                                        );
                                    } ) }

                                    {/* button actions */}
                                    <div className='ui-add-edit-communication-settings__body__form__actions'>
                                        { map( props.actions, action => {
                                            return (
                                                <Button
                                                    key={ action.name }
                                                    id= { action.name }
                                                    type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                                    { ...action }
                                                    outline={ 'cancel' === action.name ? true: false }
                                                    size='medium'
                                                    className='ui-add-edit-communication-settings__body__form__actions__action'
                                                    onClick = { isEqual( 'cancel', action.name ) ?  () => {
                                                        popover.close();
                                                        props.onCancelClick();
                                                    } : null }
                                                />
                                            );
                                        } ) }
                                    </div>
                                </form>
                            );
                        } }
                    </Form>
                </div>
            </div>
        </div>
    );
};

// set display name
wellViewAdministrationEditContact.displayName = 'wellViewAdministrationEditContact';

// set default props
wellViewAdministrationEditContact.defaultProps = {};

// prop types
wellViewAdministrationEditContact.propTypes = {};
